export default {
  setTipos(state, payload) {
    state.tipos = payload
  },

  setPrazos(state, payload) {
    state.prazos = payload
  },

  setVeiculos(state, payload) {
    state.veiculos = payload
  },

  setTipo(state, payload) {
    state.tipo = payload
  }
}
